<template>
  <li class="nav-item border-left border-right dropdown notifications">
    <!-- <a class="nav-link nav-link-icon text-center" v-d-toggle.notifications>
      <div class="nav-link-icon__wrapper">
        <i class="material-icons">&#xE7F4;</i>
        <d-badge pill theme="danger" v-if="totalUnRead > 0">{{ totalUnRead }}</d-badge>
      </div>
    </a> -->
    <d-collapse
      ref="test"
      id="notifications"
      class="dropdown-menu dropdown-menu-small"
    >
      <d-dropdown-item
        v-for="(notification, index) in notifications.slice(0, 5)"
        :key="index"
        :to="notification.action"
      >
        <div class="notification__icon-wrapper" v-d-toggle.notifications>
          <div
            class="notification__icon"
            v-html="iconFormat(notification)"
          ></div>
        </div>
        <div class="notification__content" v-d-toggle.notifications>
          <span
            class="notification__category"
            v-html="titleFormat(notification)"
          ></span>
          <p v-html="notification.message"></p>
        </div>
      </d-dropdown-item>

      <d-dropdown-item
        class="notification__all text-center"
        :to="{ name: 'my-notifications' }"
        >Voir toutes les notifications</d-dropdown-item
      >
    </d-collapse>
  </li>
</template>

<script>
import notificationsModel from "../../data/notifications/notifications";

export default {
  name: "notificationNav",
  mounted() {
    this.$services.notification
      .findAll({}, null, null, 1, 50, "creationDate", false)
      .then(({ data }) => {
        this.$store.commit("setNotifications", data.data);
      });
  },
  computed: {
    notifications() {
      return this.$store.state.user.notifications;
    },
    totalUnRead() {
      return this.$store.state.user.notifications.filter(
        (notification) => notification.read === false
      ).length;
    },
  },
  methods: {
    iconFormat(notification) {
      return notificationsModel[notification.type].icon;
    },
    titleFormat(notification) {
      return notificationsModel[notification.type].title;
    },
  },
};
</script>

<style>
.nav-link:hover {
  cursor: pointer;
}

/* IE11 Navbar flex fix. */
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .navbar-nav {
    align-items: stretch !important;
    flex: 1 1 100%;
    flex-flow: row wrap;
  }

  .nav-item.notifications {
    margin-left: auto !important;
  }
}

.min-w-160 {
  min-width: 160px !important;
}
</style>
